import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

const categoryStyle: Record<NewsItem["category"], string> = {
  作品资讯: "bg-primary-100 text-primary-800",
  人物动态: "bg-accent-100 text-accent-900",
  行业观察: "bg-secondary-100 text-secondary-900",
  站务公告: "bg-background-200 text-foreground-700",
};

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <article className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:gap-6 md:p-5">
      <div className="hidden w-16 shrink-0 flex-col items-center justify-center rounded-md bg-background-100 py-3 text-center sm:flex">
        <span className="font-heading text-2xl font-black leading-none text-primary-700">
          {item.date.slice(8, 10)}
        </span>
        <span className="mt-1 font-label text-[10px] text-foreground-500">{item.date.slice(0, 7)}</span>
      </div>
      <div className="min-w-0 flex-1">
        <div className="mb-2 flex flex-wrap items-center gap-2">
          <span className={`rounded px-1.5 py-0.5 font-label text-[10px] ${categoryStyle[item.category]}`}>
            {item.category}
          </span>
          <span className="font-label text-[11px] text-foreground-400 sm:hidden">{item.date}</span>
        </div>
        <h2 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/detail/news/${item.id}`} className="transition-colors hover:text-primary-700">
            {item.title}
          </Link>
        </h2>
        <p className="clamp-2 mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <Link
          to={`/detail/news/${item.id}`}
          className="mt-3 inline-flex items-center gap-1 font-label text-xs text-primary-700 transition-colors hover:text-primary-600"
        >
          阅读全文
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </article>
  );
}